export const ALIGN = "align";
export const SAFETY_MOVE = "safety-move";
export const PROBE_FEATURE_TCPC = "probe-feature-tcpc";
export const PROJECT_POINTS_ONTO_PLANE = "project-points-onto-plane";
export const INTERSECT_LINES = "intersect-lines";
export const SET_G5X_OFFSET = "set-g5x-offset";

export const GHOST_PROBE_OFF = "GHOST_PROBE_OFF";
export const GHOST_PROBE_ALIGN_TO_NORMAL = "GHOST_PROBE_ALIGN_TO_NORMAL";
export const GHOST_PROBE_ALIGN_TO_CURRENT_ORIENTATION = "GHOST_PROBE_ALIGN_TO_CURRENT_ORIENTATION";

export const RENDER_LAYER_MASK = 1 << 0;
export const MODEL_LAYER_MASK = 1 << 3;
